export * from './lib/core.module';
export * from './lib/event.service'
export * from './lib/language.service'
export * from './lib/loader.service'
export * from './lib/environment.model';
import { InjectionToken } from '@angular/core';
import { Environment } from './lib/environment.model';
export * from './lib/extras'
export * from './lib/data.service';
export * from './lib/core.service'
export * from './lib/uploadAdapter';
export * from './lib/cache-service.service'
export const EnvConfig = new InjectionToken<Environment>('EnvConfig');
